import React, { useState, useEffect, useRef } from 'react';
import Editor from '@monaco-editor/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faEraser } from '@fortawesome/free-solid-svg-icons';
import JsonView from '@uiw/react-json-view';
import { lightTheme } from '@uiw/react-json-view/light';
import { darkTheme } from '@uiw/react-json-view/dark';
import { Modal } from 'flowbite';

const defaultJsonViewProps = {
  collapsed: 2,
  displayDataTypes: true,
  displayObjectSize: true,
  enableClipboard: true,
  highlightUpdates: true,
  indentWidth: 15,
  objectSortKeys: false,
  shortenTextAfterLength: 50,
  quote: "'"
}

const avatar = 'https://i.imgur.com/MK3eW3As.jpg';
const longArray = new Array(10).fill(1);
const exampleJson = {
  avatar,
  string: 'Lorem ipsum dolor sit amet',
  integer: 42,
  float: 114.514,
  null: null,
  undefined,
  timer: 0,
  date: new Date('Tue Sep 13 2022 14:07:44 GMT-0500 (Central Daylight Time)'),
  array: [19, 100.86, 'test', NaN, Infinity],
  nestedArray: [
    [1, 2],
    [3, 4],
  ],
  object: {
    'first-child': true,
    'second-child': false,
    'last-child': null,
  },
  longArray,
  string_number: '1234',
};

const options = {
  placement: 'bottom-right',
  backdrop: 'dynamic',
  backdropClasses:
      'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
  closable: true,
  onHide: () => {
      console.log('modal is hidden');
  },
  onShow: () => {
      console.log('modal is shown');
  },
  onToggle: () => {
      console.log('modal has been toggled');
  },
};
const instanceOptions = {
  id: 'json-tree-view-options',
  override: true
};

const JsonViewPage = (props) => {
  const { editorTheme } = props
  const [originalInput, setOriginalinput] = useState(JSON.stringify(exampleJson, null, 2));
  const [stringOutput, setStringOutput] = useState(null);
  const [jsonViewProps, setJsonViewProps] = useState(defaultJsonViewProps)

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalinput(content);
    };
    reader.readAsText(file);
  };

  const convertDataValue = (v) => {
    switch (v) {
      case 'false':
        return false;
      case 'true':
        return true;
      default:
        return parseInt(v)
    }
  }

  const handleJsonViewChange = (e) => {
    let newValue = e.target.value
    if (['collapsed', 'shortenTextAfterLength', 'indentWidth'].includes(e.target.name)) {
      newValue = convertDataValue(newValue)
    }
    console.log(`${e.target.name}`, newValue)
    setJsonViewProps({
      ...jsonViewProps,
      [e.target.name]: newValue,
    });
  }
  const handleJsonViewChangeCheckbox = (e) => {
    const newValue = !jsonViewProps[e.target.name]
    console.log(`${e.target.name}`, newValue)
    setJsonViewProps({
      ...jsonViewProps,
      [e.target.name]: newValue,
    });
  }

  const handleShowModal = (show = true) => {
    const $targetEl = document.getElementById('json-tree-view-options');
    const modal = new Modal($targetEl, options, instanceOptions);
    if (show) {
      modal.show();
    } else {
      modal.hide();
    }
  }

  useEffect(() => {
    if (originalInput === "") {
      setStringOutput("");
    } else {
    const jsonObject = JSON.parse(originalInput);
     setStringOutput(jsonObject)
    }
  }, [originalInput])

  const renderViewOptions = () => {
    return (
      <div >
        <button
          className="block mt-4 text-white bg-blue-500 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
          onClick={handleShowModal}
        >
          View Options
        </button>
        <div
          id="json-tree-view-options"
          tabIndex={-1}
          aria-hidden="true"
          className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        >
          <div className="relative p-4 w-full max-w-md max-h-full">
            {/* Modal content */}
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              {/* Modal header */}
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Customize View Options
                </h3>
                {/* <button
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  onClick={() => handleShowModal(false)}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button> */}
              </div>
              {/* Modal body */}
              <form className="p-4 md:p-5">
                <div className="grid gap-4 mb-4 grid-cols-2">
                  <div className="col-span-2 sm:col-span-1">
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Collapsed
                    </label>
                    <select
                      value={jsonViewProps.collapsed}
                      id="collapsed"
                      name="collapsed"
                      onChange={handleJsonViewChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    >
                      <option value={false}>False</option>
                      <option value={true}>True</option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                    </select>
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <label
                      htmlFor="Indent"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Indent
                    </label>
                    <input
                      onChange={handleJsonViewChange}
                      type="number"
                      name="indentWidth"
                      id="indentWidth"
                      max={50}
                      min={5}
                      value={jsonViewProps.indentWidth}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="15"
                      required="true"
                    />
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <label
                      htmlFor="category"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Quotes
                    </label>
                    <select
                      onChange={handleJsonViewChange}
                      value={jsonViewProps.quote}
                      id="quote"
                      name="quote"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    >
                      <option value=" ">Enable Quotes</option>
                      <option value={`"`}>Double Quotes</option>
                      <option value={`'`}>Single Quotes</option>
                    </select>
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <div class="flex items-center pt-10">
                      <input name="enableClipboard" onChange={handleJsonViewChangeCheckbox} checked={jsonViewProps.enableClipboard} id="checked-checkbox-1" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="checked-checkbox-1" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        Enable Clipboard
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <div class="flex items-center">
                      <input name="displayDataTypes" onChange={handleJsonViewChangeCheckbox} checked={jsonViewProps.displayDataTypes} id="checked-checkbox-2" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        Display Data Types
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <div class="flex items-center">
                      <input name="displayObjectSize" onChange={handleJsonViewChangeCheckbox} checked={jsonViewProps.displayObjectSize} id="checked-checkbox-3" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="checked-checkbox-3" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                      Display Object Size
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <div class="flex items-center">
                      <input onChange={handleJsonViewChangeCheckbox} name="objectSortKeys" checked={jsonViewProps.objectSortKeys} id="checked-checkbox-4" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <label for="checked-checkbox-4" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        Sort Keys Through
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2">
                    <div class="flex items-center">
                      <label for="default-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Shorten Text After Length ({jsonViewProps.shortenTextAfterLength})
                      </label>
                      <input min={20} max={100} onChange={handleJsonViewChange} name="shortenTextAfterLength" id="default-range" type="range" value={jsonViewProps.shortenTextAfterLength} class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>JSON Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <Editor 
              height="50vh"
              value={originalInput}
              onChange={(value, event) => setOriginalinput(value)}
              placeholder="Please enter JSON code."
              defaultLanguage="json"
              defaultValue={originalInput}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <input
              type="file"
              accept='.json'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              type="button"
              onClick={() => document.querySelector('input[name="file1"]').click()}
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your JSON file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalinput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-full">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>JSON Tree Viewer</h3>
            { stringOutput && renderViewOptions() }
          </div>
          { stringOutput && (
            <div style={{minHeight: '30vh'}} className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
              <JsonView
                keyName="root"
                {...jsonViewProps}
                value={stringOutput}     
                style={editorTheme.includes('dark') ? darkTheme : lightTheme }
              >
                <JsonView.Quote>{jsonViewProps.quote}</JsonView.Quote>
                <JsonView.ValueQuote
                render={(props) => {
                  if (!jsonViewProps.quote?.trim()) return <span />;
                  return <span {...props}>{jsonViewProps.quote}</span>;
                }}/>
              </JsonView>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default JsonViewPage;
